<script setup lang="ts">
import { unsetModal } from '@utils/modal-util.js';
import Headline from '@components/headline.vue';
import ExpressPickLightning from '@src/express-pick/express-pick-lightning.vue';
import { ModalSize } from '@src/application/types/modal-size.ts';
import FullScreenLoader from '@components/loader/full-screen-loader.vue';

const props = withDefaults(defineProps<{
    uuid: string,
    title?: string|boolean,
    component: string|object,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    resolve: Function,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    reject: Function,
    resolveListener: string,
    rejectListener?: string|null,
    props?: object|null,
    size: ModalSize,
}>(), {
    title: false,
    rejectListener: null,
});

function resolveModal(payload: any) {
    unsetModal(props.uuid);
    props.resolve(payload);
}
function rejectModal(payload: any) {
    unsetModal(props.uuid);
    props.reject(payload);
}
</script>

<template>
    <div :class="$style.modal_layer">
        <div :class="[$style.modal, size ? $style['size_' + size] : '']">
            <ExpressPickLightning/>
            <div :class="$style.modal_content">
                <Headline v-if="title" :class="$style.title" type="h2">{{ title }}</Headline>
                <Suspense>
                    <component :is="component" v-bind="props.props ?? {}" @[resolveListener]="resolveModal" @[rejectListener]="rejectModal"/>
                    <template v-slot:fallback>
                        <FullScreenLoader/>
                    </template>
                </Suspense>
            </div>
        </div>
    </div>
</template>

<style lang="scss" module>
@use '@backgrounds' as *;

.modal_layer {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 90;
    display: grid;
    grid-template-rows: minmax(0, 1fr) max-content minmax(0, 1fr);
    grid-template-columns: minmax(0, 1fr) max-content minmax(0, 1fr);
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: $overlay-background;
}
.modal {
    grid-row-start: 2;
    grid-column-start: 2;
    background-color: #fff;
    max-width: 100vw;

    .modal_content {
        padding: 1em 1em 1.5em ;

        @media (min-width: 36em) {
            padding: 1.5em 2em 2em ;
        }
    }

    .title {
        width: 100%;
        margin-bottom: 1rem;
        text-align: center;

        @media (min-width: 33em) {
                margin-bottom: 1.3rem;
        }
    }

    @media (min-width: 33em) {
        min-width: 30em;
        max-width: 90vw;

        &.size_1 {
            width: 30vw;
            max-width: 50em;
        }
        &.size_2 {
            width: 50vw;
            max-width: 70em;
        }
        &.size_3 {
            width: 75vw;
            max-width: 100em;
        }
    }
}
</style>
